import React from 'react';
import Footer from '../../components/Footer/Footer';

function PrivacyPolicy() {

    return (
        <div className="secondary-bg">
            <div className="w-[100vw] min-h-[100vh] p-5 text-white overflow-x-hidden">
                {/* HALF CIRCLE */}
                <div
                    className="absolute top-5 primary-bg rounded-l-full w-[150px] h-[300px] right-0 md:w-[200px] md:h-[400px] lg:w-[250px] lg:h-[500px]"
                    style={{
                        zIndex: 0
                    }}
                ></div>
                <div className="relative w-full h-full px-[7%]" style={{ zIndex: 1 }}>
                    {/* HEADING */}
                    <div className="w-full py-2 mb-5 pb-5 flex items-center justify-between">
                        <img src="/assets/images/logo/dodeal-properties-white.png"
                            alt="DODEAL PROPERTIES" className="w-[100px]" />
                        {/* <div className="text-xl md:text-2xl text-center uppercase primary-text">
                            Privacy Policy
                        </div> */}
                        <div className="font-bold uppercase text-3xl md:text-4xl lg:text-5xl xl:text-6xl mt-5 text-end w-[350px] md:w-[550px] lg:w-[750px] xl:w-[950px]">
                            Privacy Policy
                        </div>
                    </div>
                    {/* CONTENT */}
                    <div className="my-5 py-5 text-base flex flex-col gap-8">
                        <div>
                            This privacy policy explains how we collect information from you and the purposes for which it is used.
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Information you provide
                            </div>
                            <div>
                                You may provide us with personal contact information in several ways, including but not limited to sending a property enquiry, corresponding with us via email, completing a survey, entering a competition, completing a review, providing feedback, or reporting an issue. We only store your personal data after you have consented by agreeing to our terms and conditions on the relevant form.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Information we collect
                            </div>
                            <div>
                                We automatically collect metadata from your web browser, which may include the type and version, device make and model, IP address, referral domain, and browser language setting.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Ways in which we may share your personal information
                            </div>
                            <div>
                                We may provide your name, email, and phone number to agents when you send a property enquiry through DODEAL PROPERTIES. Once this data is shared, the agent’s own privacy policy will apply. We may also send information about your visit to analytics and search engine providers to improve our services. This data may include your IP address, pages visited, and browser type but does not contain any direct personal identifiers such as your name or email address. Additionally, we may share your metadata with advertising networks to serve relevant ads. If DODEAL PROPERTIES or its assets are acquired, the user data we hold will be part of the transfer. If we obtain professional advice (e.g., from lawyers or financial advisors), we may disclose your personal information. We may also disclose your personal information if required by a government or regulatory authority.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Ways in which we use your personal information
                            </div>
                            <div>
                                <li>
                                    Fulfilling your requests, such as forwarding property enquiries to agents or developers.
                                </li>
                                <li>
                                    Providing you with information on DODEAL PROPERTIES services that may interest you. Any marketing emails we send will include an option to unsubscribe.
                                </li>
                                <li>
                                    Enhancing your experience of our services, e.g., ensuring content is presented in the most effective manner for your device.
                                </li>
                                <li>
                                    Delivering relevant advertising to you on our site or other sites operated by DODEAL PROPERTIES.
                                </li>
                                <li>
                                    Internal business administration, e.g., data analysis, troubleshooting, testing, and research.
                                </li>
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Storing your personal information
                            </div>
                            <div>
                                We may store your information on secure servers located worldwide. By submitting your personal information, you agree to this transfer, storing, or processing. We rely on approved data transfer mechanisms to ensure that your personal information is adequately safeguarded. While we use strict procedures to secure your data, we cannot guarantee its security. Any data you send to us is done at your own risk. Where you have a password to access certain parts of our website, you are responsible for keeping that password confidential. You must not share your password with anyone.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Requesting data deletion
                            </div>
                            <div>
                                We retain your personal information for as long as necessary for the purposes for which it was collected. If you would like to delete your information from our servers, you may request us to do so by contacting us.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Cookies
                            </div>
                            <div>
                                We use cookies to distinguish you from other users of DODEAL PROPERTIES, allowing us to customize your experience on our website, e.g., by remembering your chosen currency or favorite properties. The Google advertising network uses a cookie to record your activity (including pages visited) and estimate what information interests you most. They use this information in accordance with their own privacy policies.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Links to third-party websites
                            </div>
                            <div>
                                Where our website contains links to other websites, this privacy policy does not apply to those other websites, and we do not accept liability for the content of any other website. Please check the privacy policy of any other website before submitting any personal information to it.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Contacting us
                            </div>
                            <div>
                                Any changes we make to this policy in the future will be posted on this page. If you have any questions regarding this privacy policy, you may contact us.
                            </div>
                        </div>
                        <div>
                            Feel free to adjust any section or add more specific details as needed.
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
